// extracted by mini-css-extract-plugin
export default {"root":"InvoiceSentModal_root__PVihx","footer":"InvoiceSentModal_footer__jnWJ1"};